@if (!showResults()) {
  <app-roleplay-post-call
    [state]="currentState()"
    [practiceCallUuid]="resolvedPracticeCallUuid"
    [callType]="resolvedCallType()"
    [endedEarly]="endedEarly"
    [moduleAssignmentUuid]="resultsService.conversationalResults()?.moduleAssignmentUuid ?? ''"
    [callUuid]="resultsService.conversationalResults()?.callUuid ?? ''"
    (viewResults)="onViewResults()"
    (returnToPathway)="returnToPathway.emit()"
  ></app-roleplay-post-call>
} @else if (!resultsService.resultReady()) {
  <div class="loading-container">
    <qai-loading size="medium" />
  </div>
} @else {
  <div class="results">
    @if (isMobile()) {
      <div class="mobile-stack">
        <div class="result-card">
          <app-result-overall-score
            [scoresArray]="resultsService.scoresArray()"
            [scoreOverall]="resultsService.scoreOverall()"
          />
        </div>

        @if (
          resultsService.scoreMessageAdherence().length ||
          resultsService.flattenedSections().length
        ) {
          <div class="result-card">
            <app-result-messaging
              [messageAdherences]="resultsService.scoreMessageAdherence()"
              [flattenedSections]="resultsService.flattenedSections()"
              [isMessageAdherenceV2]="resultsService.isMessageAdherenceV2()"
              [overallScore]="resultsService.messageAdherenceScore()"
              [scoreCriteria]="resultsService.scoreCriteria()"
            />
          </div>
        }

        @if (resultsService.methodology()?.length) {
          <div class="result-card">
            <app-result-methodology
              [objectives]="resultsService.methodology()!"
              [scoreCriteria]="resultsService.scoreCriteria()"
            />
          </div>
        }

        @if (resultsService.skills()?.length) {
          <div class="result-card">
            <app-result-skills [skills]="resultsService.skills()!" />
          </div>
        }

        @if (resultsService.userTranscript(); as userTranscript) {
          <div class="result-card">
            <app-result-call-transcript [transcriptResponse]="userTranscript" />
          </div>
        }

        @if (resultsService.showAccuracy()) {
          <div class="result-card">
            <app-result-accuracy
              [state]="resultsService.accuracyState()"
              [claims]="resultsService.accuracyClaims()"
            />
          </div>
        }
      </div>
    } @else {
      <qai-carousel (cardWidthChange)="onCardWidthChange($event)">
        <!-- Card 1: Overall Score -->
        <div qaiCarouselItem class="result-card">
          <app-result-overall-score
            [scoresArray]="resultsService.scoresArray()"
            [scoreOverall]="resultsService.scoreOverall()"
          />
        </div>

        <!-- Card 2: Messaging (shown when message adherence data is available) -->
        @if (
          resultsService.scoreMessageAdherence().length ||
          resultsService.flattenedSections().length
        ) {
          <div qaiCarouselItem class="result-card">
            <app-result-messaging
              [messageAdherences]="resultsService.scoreMessageAdherence()"
              [flattenedSections]="resultsService.flattenedSections()"
              [isMessageAdherenceV2]="resultsService.isMessageAdherenceV2()"
              [overallScore]="resultsService.messageAdherenceScore()"
              [scoreCriteria]="resultsService.scoreCriteria()"
            />
          </div>
        }

        <!-- Card 3: Methodology (shown when SCORE_CUSTOMIZED objectives are available) -->
        @if (resultsService.methodology()?.length) {
          <div qaiCarouselItem class="result-card">
            <app-result-methodology
              [objectives]="resultsService.methodology()!"
              [scoreCriteria]="resultsService.scoreCriteria()"
            />
          </div>
        }

        <!-- Card 4: Skills (shown when SCORE_SKILLS data is available) -->
        @if (resultsService.skills()?.length) {
          <div qaiCarouselItem class="result-card">
            <app-result-skills [skills]="resultsService.skills()!" />
          </div>
        }

        @if (resultsService.userTranscript(); as userTranscript) {
          <div qaiCarouselItem class="result-card">
            <app-result-call-transcript [transcriptResponse]="userTranscript" />
          </div>
        }

        <!-- Card 6: Accuracy (shown when the sim has accuracy feedback enabled with documents) -->
        @if (resultsService.showAccuracy()) {
          <div qaiCarouselItem class="result-card">
            <app-result-accuracy
              [state]="resultsService.accuracyState()"
              [claims]="resultsService.accuracyClaims()"
            />
          </div>
        }
      </qai-carousel>
    }
  </div>
}
